import React, { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import frTranslations from "@/i18n/fr.json";
import enTranslations from "@/i18n/en.json";

const dictionaries = {
  fr: frTranslations,
  en: enTranslations,
};

const I18nContext = createContext({
  lang: "fr",
  t: (key) => key,
  dict: frTranslations,
});

const resolvePath = (obj, path) => {
  return path.split(".").reduce((acc, part) => {
    if (acc && typeof acc === "object" && part in acc) return acc[part];
    return undefined;
  }, obj);
};

export const detectLangFromPath = (pathname) => {
  if (!pathname) return "fr";
  if (pathname.startsWith("/en")) return "en";
  return "fr";
};

export const I18nProvider = ({ children }) => {
  const location = useLocation();
  const lang = detectLangFromPath(location.pathname);
  const dict = dictionaries[lang] || dictionaries.fr;

  const value = useMemo(
    () => ({
      lang,
      dict,
      t: (key, fallback) => {
        const value = resolvePath(dict, key);
        if (value === undefined || value === null) {
          return fallback !== undefined ? fallback : key;
        }
        return value;
      },
    }),
    [lang, dict]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
